/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1UploadAssetMetadata } from '../models/V1UploadAssetMetadata';
import { HttpFile } from '../http/http';

export class V1UploadAssetRequest {
    'metadata'?: V1UploadAssetMetadata;
    /**
    * Raw bytes of the image file.
    */
    'chunk'?: HttpFile;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "V1UploadAssetMetadata",
            "format": ""
        },
        {
            "name": "chunk",
            "baseName": "chunk",
            "type": "HttpFile",
            "format": "binary"
        }    ];

    static getAttributeTypeMap() {
        return V1UploadAssetRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

